import { render } from "./g-cloudflare-turnstile.vue?vue&type=template&id=467ec264&ts=true"
import script from "./g-cloudflare-turnstile.vue?vue&type=script&lang=tsx"
export * from "./g-cloudflare-turnstile.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__